let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5OUMf")).then(() => parcelRequire('Gk4RP'));